export const SET_ZEBRA_APPS_VERSION_MAP = 'SET_ZEBRA_APPS_VERSION_MAP';
export const SET_ZEBRA_APPS_LIST = 'SET_ZEBRA_APPS_LIST';
